import { useEffect, useState } from 'react';
import { scrollbarWidth } from '@xobotyi/scrollbar-width';
export function useScrollbarWidth() {
  const [width, setWidth] = useState(scrollbarWidth());
  useEffect(() => {
    if (typeof width !== 'undefined') {
      return;
    }
    let rafId = null;
    const handler = () => {
      rafId = requestAnimationFrame(() => {
        setWidth(scrollbarWidth());
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handler);
    } else {
      handler();
    }
    return () => {
      document.removeEventListener('DOMContentLoaded', handler);
      if (rafId) cancelAnimationFrame(rafId);
    };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
  return width;
}